import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import '../styles/FoundationGrid.scss';
import '../styles/MUIOverrides.scss';
import '../styles/index.scss';
import '../styles/App.scss';
import Kiosk from './Kiosk/Kiosk';
import LoginFlow from './LoginFlow/LoginFlow';
import SlackFeedback from 'react-slack-feedback';
import SlackService from '../services/slack.service';

const App = () => {
    return (
        <Router>
            <div className="App">
                <div className="FoundationGrid">
                    <Route exact path="/:roomName/kiosk" render={({ match }) => <Kiosk match={match} />} />
                    <Route exact path="/:roomName/signin" render={({ match }) => <LoginFlow match={match} />} />
                </div>
                <SlackFeedback
                        onSubmit={SlackService.sendToSlack}
                        channel="#general"
                        emoji=":bug:"
                        disabled={false} />
            </div>
        </Router>
    );
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.jsx